import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  showLoader$ : Observable<any>;

  constructor(private loaderService:LoaderService) { }

  ngOnInit() {
    // this.showLoader$=this.loaderService.showLoader$;
    this.loaderService.showLoader$.subscribe(
      (load) => {
        this.showLoader$=load;
      }
    );
  }

  

}
